import React from "react";

const Blink: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return <span className="blink">{children}</span>;
};

export default Blink;
